import Hoducc from './chat'


const component = {
    Hoducc
}

export default component;